import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { useParams } from "react-router-dom";
import './IpoDetailsNew.css'
import ipoprofileimg from "../../../Images/ipo/ksh-profile.png"
import ipopdfimg from "../../../Images/ipo/ipo-pdf.svg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { format, parseISO } from 'date-fns';
import axios from "axios";
import { ApiUrlDomain } from "../../Configration/Configrationnew";
import { useDispatch } from 'react-redux';
import { useCookies } from "react-cookie";
import { setState } from '../../features/User/UserSlice';
import TrackApi from "../../Activity_Track/TrackApi";
import Swal from "sweetalert2";

function IpoDetailsNew() {
    const EyeSlash = <FontAwesomeIcon icon={faEyeSlash} />
    const Eye = <FontAwesomeIcon icon={faEye} />
    const [showOtp, setShowOtp] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [data, setData] = useState([]);
    const [datatwo, setDatatwo] = useState([]);
    const [Datathree, setDatathree] = useState([]);
    const [Datafour, setDatafour] = useState([]);
    const [Datafive, setDatafive] = useState([]);
    const [Datasix, setDatasix] = useState([]);
    const { getCompName, getcocode } = useParams();
    const [dataGroup, setDataGroup] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDatatwo, getDataGroup, getDatathree, getDatafour, getDatafive, getDatasix;
    const [items, setItems] = useState([]);
    const [comanyname, setcomanyname] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    let PageSize = 8;
    const [newUserMoberror, setNewUserMoberror] = useState('');
    const [otpis1, setotpis1] = useState('');
    const [otpis2, setotpis2] = useState('');
    const [otpis3, setotpis3] = useState('');
    const [otpis4, setotpis4] = useState('');
    const [newmobotpverify, Setnewmobotpverify] = useState(false);
    const [seconds, setSeconds] = useState(30);
    const [resendDisabled, setResendDisabled] = useState(true);
    const [verifyloader, setverifyloader] = useState(false);
    const dispatch = useDispatch();
    const [cookies, setCookie] = useCookies(['LeadId']);
    const [isGoogleLoginOpened, setisGoogleLoginOpened] = useState(true);
    const [showmobile, setshowmobile] = useState(false);
    const [isOtpActive, setIsOtpActive] = useState(false);

    const [NameUser, setNameUser] = useState('');
    const [mob_no, setNewUserMobNo] = useState([]);
    const [email, setemail] = useState('');


    const formatDate = (date) => {
        return date != null ? format(parseISO(date), 'dd-MMM-yyyy') : '';
    };

    const downloadPdf = (e) => {
        e.preventDefault();
        if (data[0].rhplink) {
            window.open(data[0].rhplink, '_blank');
        } else {
            alert("PDF link is not available.");
        }
    };

    const handleGetStarted = () => {
        setIsOtpActive(true);
    };



    // Function to check if the date is today or in the past
    const isPastOrPresent = (date) => {
        const currentDate = new Date();
        const eventDate = parseISO(date);
        return eventDate <= currentDate;
    };

    useEffect(() => {
        if (getcocode != "") {
            const getUrl = BaseURL + "Iposynopsis";
            fetch(`${getUrl}/1/${getcocode}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/2/${getcocode}`)
                .then((response) => response.json())
                .then((datatwo) => {
                    getDatatwo = datatwo.data;
                    setDatatwo(getDatatwo);
                })
                .catch((error) => {
                });


            fetch(`${getUrl}/3/${getcocode}`)
                .then((response) => response.json())
                .then((datathree) => {
                    getDatathree = datathree.data;
                    setDatathree(getDatathree);
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/4/${getcocode}`)
                .then((response) => response.json())
                .then((datafour) => {
                    getDatafour = datafour.data;
                    setDatafour(getDatafour);
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/5/${getcocode}`)
                .then((response) => response.json())
                .then((datafive) => {
                    getDatafive = datafive.data;
                    setDatafive(getDatafive);
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/6/${getcocode}`)
                .then((response) => response.json())
                .then((datasix) => {
                    getDatasix = datasix.data;
                    setDatasix(getDatasix);
                })
                .catch((error) => {
                });

            const getUrlGroup = BaseURL + "GroupMaster";
            fetch(`${getUrlGroup}`)
                .then((response) => response.json())
                .then((dataG) => {
                    getDataGroup = dataG.data;
                    setDataGroup(getDataGroup);
                })
                .catch((error) => {
                });
        }
    }, [getcocode]);

    useEffect(() => {
        if (!data || data.length === 0) return;
        if (!Datafour || Datafour.length === 0) return;
        const safeDate = (date) => {
            if (!date) return "";
            return format(parseISO(date), "dd-MMM-yyyy");
        };
        const formattedItems = [
            { data: "Open Date", value: safeDate(data[0].OPENDATE) },
            { data: "Close Date", value: safeDate(data[0].CLOSDATE) },
            { data: "Listing Date", value: safeDate(data[0].listdate) },
            { data: "IPO Price Range", value: `₹ ${data[0].ISSUEPRICE} to ₹ ${data[0].IssuePri2}` },
            { data: "IPO Size", value: `₹ ${data[0].issuesize} Cr` },
            {
                data: "Listing Exchange",
                value: `${Datafour?.[0]?.LISTING || ""} ${Datafour?.[1]?.LISTING || ""}`
            },
        ].filter(item => item.value);
        setItems(formattedItems);
        setcomanyname(data[0].lname);
        setActiveIndex(0);
    }, [data, Datafour]);


    useEffect(() => {
        if (items.length === 0) return;
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) =>
                prevIndex === items.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);
        return () => clearInterval(interval);
    }, [items]);

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    const loginwithemailnewflow = () => {
        if (mob_no != "" && mob_no.toString().length === 10) {
            axios.get(`${ApiUrlDomain}/otpSend?phone_no=${mob_no}`).then((res) => {
                if (res.data == 'OTP sent successfully') {
                    setotpis1('')
                    setotpis2('')
                    setotpis3('')
                    setotpis4('')
                    setisGoogleLoginOpened(false);
                    Setnewmobotpverify(true);
                    setshowmobile(false);
                    setSeconds(30);
                    setResendDisabled(true);
                }
            }).catch((error) => {
                console.log(error);
            })
        }
        else {
            setNewUserMoberror("Please enter valid mobile number");
            return false;
        }
    }
    const handleNewUserMobileNumber = event => {
        const re = /^[0-9\b]+$/;
        setshowmobile(event.target.value.length);
        if (event.target.value.length <= 10 && re.test(event.target.value)) {
            setNewUserMobNo(parseInt(event.target.value));
        }
        if (event.target.value.length == 0) {
            setNewUserMobNo("");
        }
        setNewUserMoberror("");
    };
    const NewsignFlow = () => {
        
        //console.log("NewsignFlow=======", NewsignFlow)
        const fullOtp = otpis1 + otpis2 + otpis3 + otpis4;
        //console.log("setOtp========", fullOtp)
        if (fullOtp.length !== 4) {
            alert("Please enter valid 4-digit OTP");
            return;
        }
        setverifyloader(true);
        axios.get(`${ApiUrlDomain}/otpValidate?phone_no=${mob_no}&otp=${fullOtp}`).then((res) => {
            if (res.data == 'OTP validated successfully') {
                axios.post(`${ApiUrlDomain}/signupRetriveLead`, { "phone": mob_no }).then((res) => {
                    if (res && res.data.length > 0) {
                        const leadId = res.data[0].prospectID;
                        setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                        const payloadData = {
                            "RelatedProspectId": leadId,
                            "ActivityNote": "Your Activity Note",
                            "mx_Custom_1": "Home",
                            "mx_Custom_2": "Your Activity Note",
                            "mx_CustomObject_81": window.location.href,
                            "uniqueid": "D000228D-FBDA-4F38-A0BA-5E5614484C6B"
                        }
                        //console.log("signupRetriveLead==========", payloadData)

                        if (res.data[0].prospectStage == "Customer" && res.data[0].mx_Lead_Status == "Active" && res.data[0].mx_Status == "Enabled") {
                            dispatch(setState({
                                "email": mob_no,
                                "name": NameUser,
                                "ProspectStage": res.data[0].prospectStage,
                                "mx_Lead_Status": res.data[0].mx_Lead_Status,
                                "mx_Status": res.data[0].mx_Status
                            }));
                            Setnewmobotpverify(false);
                            setverifyloader(false);
                            TrackApi(payloadData);
                            setNewUserMobNo('');
                        }
                        Setnewmobotpverify(false);
                        let redirecturlsignup = document.createElement('a');
                        //redirecturlsignup.href = "https://kyc.moneysukh.com";
                        redirecturlsignup.href = "https://kyc.moneysukh.com/email";
                        redirecturlsignup.target = '_blank';
                        redirecturlsignup.style.display = 'none';
                        document.body.appendChild(redirecturlsignup);
                        redirecturlsignup.click();
                        document.body.removeChild(redirecturlsignup);
                        TrackApi(payloadData);
                        setverifyloader(false);

                    }
                    else {
                        let bodydataleadapi = [
                            {
                                "Attribute": "EmailAddress",
                                "Value": email
                            }, {
                                "Attribute": "Phone",
                                "Value": mob_no
                            }, {
                                "Attribute": "mx_Primary_Email_ID",
                                "Value": email
                            }, {
                                "Attribute": "SearchBy",
                                "Value": "mx_Primary_Email_ID"
                            }, {
                                "Attribute": "Source",
                                "Value": "Website"
                            }, {
                                "Attribute": "FirstName",
                                "Value": NameUser
                            },
                            {
                                "Attribute": "mx_Vendor_Unique_Id",
                                "Value": "",
                            },
                            {
                                "Attribute": "mx_website_URL_React",
                                "Value": window.location.href
                            }
                        ];
                        axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async (responelead) => {
                            console.log("uhhhhhh", responelead);
                            const leadId = responelead && responelead.data && responelead.data.leadId;
                            setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                            const payloadData = {
                                "RelatedProspectId": leadId,
                                "ActivityNote": "Your Activity Note",
                                "mx_Custom_1": "Home",
                                "mx_Custom_2": "Your Activity Note",
                                "mx_CustomObject_81": window.location.href
                            }
                            TrackApi(payloadData);
                            let redirecturlsignup = document.createElement('a');
                            //redirecturlsignup.href = "https://kyc.moneysukh.com";
                            redirecturlsignup.href = "https://kyc.moneysukh.com/email";
                            redirecturlsignup.target = '_blank';
                            redirecturlsignup.style.display = 'none';
                            document.body.appendChild(redirecturlsignup);
                            redirecturlsignup.click();
                            document.body.removeChild(redirecturlsignup);
                        }).catch((error) => {
                            setverifyloader(false);
                        })
                    }
                }).catch((error) => {
                    console.log(error);
                    setverifyloader(false);
                })
            } else if (res.data == 'Invalid OTP') {
                Swal.fire(`Invalid OTP Please Enter Correct Otp`);
                setverifyloader(false);
            }
        }).catch((error) => {
            setverifyloader(false);
            console.log(error);
        })
    }
    return (
        <>
            <div className="ipodetails-page py-4 py-lg-5">
                <div className="container">
                    <section class="ipodetailsbreadcrum-section">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                <li><a href="/market/ipo">IPO</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                <li>Forthcoming IPO</li>
                            </ol>
                        </nav>
                    </section>

                    <section class="ipodetails-section">
                        <div class="ipodetails-wrapper">
                            <div className="ipodetails-left">
                                <div className="ipodetails-profile">
                                    <div className="ipodetails-imgprofile"><img src={ipoprofileimg}></img> </div>
                                    <div className="ipodetails-textprofile"><h2> {comanyname}</h2></div>
                                </div>
                                <div className="ipodetails-status">
                                    <div className="ipodetailsstatus-imgprofile">
                                        <ul>
                                            <li>Status: <span>Live</span></li>
                                            <li>RHP <a href="#" title={comanyname} onClick={downloadPdf} ><span className="ipodetails-pdficon"><img src={ipopdfimg}></img></span></a></li>
                                        </ul>
                                    </div>
                                    <div className="ipodetailsstatus-textpanel">
                                        <div className="ipodetailsstatus-text">
                                            ₹ {((data[0]?.ISSUEPRICE ?? 0) * (data[0]?.MIN_APPLN ?? 0)).toLocaleString("en-US")} <span><small className="px-1"><i>/</i></small>  {data[0]?.MIN_APPLN} shares</span>
                                            <p>Minimum Investment</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="ipodetails-infogrid">
                                    <h2>{comanyname} IPO</h2>
                                    <ul id="ipolist">
                                        {items.map((item, index) => (
                                            <li key={index} className={`list-box ${activeIndex === index ? "active" : ""}`}>
                                                <p>{item.data}  <strong>{item.value}</strong></p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="ipodetails-right">
                                <div className="ipodetails-rightinner">
                                    <p class="applyipo-heading">Open Free Demat Account</p>
                                    <div className="applyipo-form">
                                        <form className="maincta_form">
                                            <div className={`form-group mb-3 mb-md-4 ${isOtpActive ? "hide_otp" : ""}`}>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">+91</span>
                                                    <input type="number" class="form-control countryCode" id="EnterMobileNumber" name="mobileNumber" placeholder="Enter Mobile Number" onChange={handleNewUserMobileNumber} value={mob_no} max={10} />
                                                </div>
                                            </div>

                                            {/* otp section   */}
                                            <div className={`form-group mb-3 mb-md-4 hide_otp ${isOtpActive ? "active_otp" : ""}`}>
                                                <div class="inputctaopt_grid">
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowOtp(!showOtp)}>{showOtp ? Eye : EyeSlash}</div>
                                                        </div>
                                                        <div class="inputctaopt_group form-control">
                                                            <div className="inputctaopt"> <input size="1" type={showOtp ? "text" : "password"} className={`form-control`} onChange={(e) => setotpis1(e.target.value)} value={otpis1} id="otp1" maxlength="1" autocomplete="off" /></div>
                                                            <div className="inputctaopt"> <input size="1" type={showOtp ? "text" : "password"} className={`form-control`} onChange={(e) => setotpis2(e.target.value)} value={otpis2} id="otp2" maxlength="1" autocomplete="off" /></div>
                                                            <div className="inputctaopt"> <input size="1" type={showOtp ? "text" : "password"} className={`form-control`} onChange={(e) => setotpis3(e.target.value)} value={otpis3} id="otp3" maxlength="1" autocomplete="off" /></div>
                                                            <div className="inputctaopt"> <input size="1" type={showOtp ? "text" : "password"} className={`form-control`} onChange={(e) => setotpis4(e.target.value)} value={otpis4} id="otp4" maxlength="1" autocomplete="off" /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`applyipoform-btn hide_otp ${isOtpActive ? "active_otp" : ""}`}>
                                                <button class="applyipoform-submitbtn" type="submit" onClick={() => NewsignFlow()}>Submit OTP </button>
                                            </div>
                                            <div className={`applyipoform-btn ${isOtpActive ? "hide_otp" : ""}`}>
                                                <button type="button" class="btn btn-primary w-100" onClick={() => { handleGetStarted(); loginwithemailnewflow() }}>Apply Now</button>
                                            </div>
                                        </form>
                                    </div>
                                    <p class="ipotnc-text">By proceeding, you agree to all <a href="/TermsCondition">T&amp;C*</a></p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="ipodetails-timelinesection">
                        <h2>{comanyname} Timeline</h2>
                        <div className="ipodetails-timelinewrapper">
                            {currentTableData && currentTableData.map(
                                ({CreditofsharestoDemataccountDate, RefundDate, AllotmentDate, OPENDATE, CLOSDATE, listdate}) => (
                                    <>
                                        <div className="ipodetails-timelinetabslider">
                                            <ul className="ipodetails-timelinetabsteps">
                                                <li className={isPastOrPresent(OPENDATE) ? 'active' : ''}>
                                                    <p>Bidding starts</p>
                                                    <span>{formatDate(OPENDATE)}</span>
                                                </li>
                                                <li className={isPastOrPresent(CLOSDATE) ? 'active' : ''}>
                                                    <p>Bidding ends</p>
                                                    <span>{formatDate(CLOSDATE)}</span>
                                                </li>
                                                <li className={isPastOrPresent(AllotmentDate) ? 'active' : ''}>
                                                    <p>Allotment finalisation</p>
                                                    <span>{formatDate(AllotmentDate)}</span>
                                                </li>
                                                <li className={isPastOrPresent(RefundDate) ? 'active' : ''}>
                                                    <p>Refund initiation</p>
                                                    <span>{formatDate(RefundDate)}</span>
                                                </li>
                                                <li className={isPastOrPresent(CreditofsharestoDemataccountDate) ? 'active' : ''}>
                                                    <p>Demat transfer</p>
                                                    <span>{formatDate(CreditofsharestoDemataccountDate)}</span>
                                                </li>
                                                <li className={isPastOrPresent(listdate) ? 'active' : ''}>
                                                    <p>Listing</p>
                                                    <span>{formatDate(listdate)}</span>
                                                </li>
                                            </ul>
                                    </div>
                            </>))}
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default IpoDetailsNew;
